export const isNullOrEmpty = (input) => {
    return input === 'undefined' || !input
}

